import { RELOAD_IMG, SET_USER } from '../reducers/user-reducer'
import User from '../constants/user'
import getPayeService from '../../api/envService'
import { CLIENT_LOGO_CLIENT } from '../../api/endpoints'

export function setUser(user = User.NULL) {
  return { type: SET_USER, value: user }
}
export function reloadImage(value) {
  return { type: RELOAD_IMG, value }
}

export const updateLogo = (files, client) => dispatch => {
  return Promise.resolve()
    .then(() => dispatch(reloadImage(0)))
    .then(() => getPayeService().patchFile(CLIENT_LOGO_CLIENT, files[0], 'dataFile', client))
    .finally(() => dispatch(reloadImage(1)))
}
